<template>
  <div class="wrap">
      <div class="steps display-flex">
          <div class="img">
               <img src="../assets/steps01.svg" alt="">
          </div>
          <div class="text">
              <h4>step 1</h4>
              <p>Download and install the app from play <br> store or app store. The app will guide you <br> through the log in process. </p>
          </div>
      </div>
      <div class="steps display-flex">
           <div class="img">
               <img src="../assets/step_2.svg" alt="">
           </div>
          <div class="text">
              <h4>step 2</h4>
              <p>On the home page browse through stores <br> closest to you and add desired items to your cart. </p>
          </div>
      </div>
      <div class="steps display-flex">
           <div class="img">
               <img src="../assets/step_3.svg" alt="">
           </div>
          <div class="text">
              <h4>step 3</h4>
              <p>After your shopping process is completed, <br> you can securely pay for your stuff and get <br> it delivered to you in no time.</p>
          </div>
      </div>
  </div>
</template>

<script>
export default {
name: 'Table'
}
</script>

<style lang="scss" scoped>
  .wrap{
     width:100%;
      font-family: 'Inter', sans-serif;
      .steps{
        padding:35px 45px;
        border: 1px solid #AB0519;
        box-sizing: border-box;
        .img{
            width:96px;
            height: 96px;
            img{
                width: 100%;
            }
        }
        .text{
            width:60%;
            h4{
              text-transform: uppercase;
              margin: 10px 0px;
              font-size: 0.98em;
            }
            p{
               font-size: 0.9em;
               font-weight: 500;
               line-height: 20px;
            }
        }
        &:nth-child(1){
          background:#AB0519;
          color: white;
        }
        &:nth-child(2){
         background-color: #FFE9EC;
        }
        &:nth-child(3){
        background-color:#FFE9EC;
        }
      }
  }
  @media (max-width:1000px){
 .wrap{
     .steps{
         .img{
             width:86px;
         }
     }
 }
 }

 @media(max-width:700px){
     .wrap{
         .steps{
             .img{
                 display: none;
             }
             .text{
                 width:100%;
             }
         }
     }
 }
 @media (max-width:450px){
     .wrap{
         .steps{
             padding:30px 15px;
         }
     }
 }
</style>